import type { CardSort, EnergySettings, Kind, Rarity, Role, Settings, ShieldKind } from './types';

export const PALETTE = [
  '#3f8f6b', '#d08a2e', '#2f7f8f', '#c4566b', '#7a5bb5', '#e06b3f', '#4a62b3',
  '#7f9137', '#3d93c9', '#a35d3a', '#5b8a8a', '#b5507f', '#6b7d2a', '#8a5bb5'
];

export const KINDS: Kind[] = ['fiz', 'gar', 'emo', 'soc'];

export const EKINDS: Record<Kind, string> = {
  fiz: 'fiziskā',
  gar: 'garīgā',
  emo: 'emocionālā',
  soc: 'sociālā'
};

/** Datīvs: “−20% fiziskajai slodzei”. */
export const EKD: Record<ShieldKind, string> = {
  fiz: 'fiziskajai slodzei',
  gar: 'garīgajai slodzei',
  emo: 'emocionālajai slodzei',
  soc: 'sociālajai slodzei',
  all: 'visām slodzēm'
};

export const EKIND_SHORT: Record<ShieldKind, string> = {
  fiz: 'fiz.',
  gar: 'gar.',
  emo: 'emoc.',
  soc: 'soc.',
  all: 'visām'
};

export const EROLES: Record<Role, string> = {
  sleep: 'Miegs (uzlādē naktī)',
  food: 'Ēdiens (uzlādē ēdienreizēs)',
  charge: 'Uzlādē dienā',
  drain: 'Patērē',
  shield: 'Noturība'
};

/** Lomas lieluma maksimums: sleep/food — % no ietilpības, charge/drain — vienības diennaktī, shield — %. */
export const EMAX: Record<Role, number> = { sleep: 100, food: 80, charge: 40, drain: 60, shield: 80 };

/** Ietilpības robežas (vienības). */
export const CAP = {
  baseMin: 20,
  baseMax: 200,
  min: 10,
  max: 300,
  tierUnits: 50
} as const;

/** Enerģijas vienības saīsinājums tekstos. */
export const EU = 'v.';

export const RAR: Record<Rarity, [string, string]> = {
  c: ['Parasta', '●'],
  u: ['Neparasta', '◆'],
  r: ['Reta', '★'],
  l: ['Leģendāra', '✦']
};

export const DEFAULT_SETTINGS: Settings = {
  view: 'main',
  links: 'all',
  threshold: 4,
  compare: null,
  tz: 'Europe/Riga',
  cardSort: 'added-desc'
};

/** Kāršu kārtošanas veidi (secība izvēlnē). */
export const CARD_SORTS: [CardSort, string][] = [
  ['added-desc', 'Jaunākās vispirms'],
  ['added-asc', 'Vecākās vispirms'],
  ['name', 'Alfabētiski (A–Z)'],
  ['category', 'Pēc kategorijām']
];

/** Cik kāršu klājā parāda uzreiz (un pievieno ar “Ielādēt vēl”). */
export const DECK_PAGE = 30;

export const DEFAULT_ENERGY: EnergySettings = {
  wake: '07:00',
  bed: '23:00',
  base: 25,
  baseKind: 'fiz',
  capacity: 100,
  meals: ['08:00', '13:00', '19:00'],
  anchor: null
};

export const LIMITS = {
  nodeName: 60,
  note: 400,
  linkLabel: 40,
  cardName: 40,
  flavor: 160,
  cardEffects: 8,
  cardRules: 6,
  cardStacks: 4,
  stackEffects: 4,
  stackLabel: 40,
  tiers: 6,
  meals: 6,
  nodes: 300,
  cards: 200
} as const;
